function isValidVideoSize(file, maxAllowedSize) {
  if (maxAllowedSize && file.size > maxAllowedSize) {
    return false;
  } else {
    return true;
  }
}

export default isValidVideoSize;
